import { HttpContextToken, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { get } from 'lodash';
import { pathToRegexp } from 'path-to-regexp';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { formEditIgnorePaths } from './notification-ignore-paths';

export const BYPASS_ERROR_NOTIFICATION = new HttpContextToken(() => false);

@Injectable()
export class ErrorNotificationsInterceptor implements HttpInterceptor {
  private readonly ignorePaths = [...formEditIgnorePaths];
  private readonly messages: any = {
    401: 'Your session has expired. Please sign-in to continue.',
    403: 'Sorry, you do not have permission to access this resource.',
    404: 'Sorry, the resource you requested does not exist.',
    default: 'Sorry, an error occurred.',
  };

  constructor(private readonly snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const pathname = new URL(request.url).pathname;

    return next.handle(request).pipe(catchError((error) => this.handleErrorEvent(request, error, pathname)));
  }

  ignore(pathname: string) {
    return this.ignorePaths.some((path) => {
      return pathToRegexp(path, undefined, { end: true }).exec(pathname);
    });
  }

  private handleErrorEvent(request: HttpRequest<any>, error: any, pathname: string) {
    const bypass = request.context.get(BYPASS_ERROR_NOTIFICATION);
    if (error instanceof HttpErrorResponse && !this.ignore(pathname) && !bypass) {
      this.snackBar.open(get(this.messages, error.status, this.messages.default));
    }

    return throwError(error);
  }
}
